import React from "react";

const NeueContentsListStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9804 16C15.9804 15.7239 16.2086 15.5 16.4902 15.5C16.7718 15.5 17 15.7239 17 16C17 16.2761 16.7718 16.5 16.4902 16.5C16.2086 16.5 15.9804 16.2761 15.9804 16Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9804 10C15.9804 9.7239 16.2086 9.50001 16.4902 9.50001C16.7718 9.50001 17 9.7239 17 10C17 10.2761 16.7718 10.5 16.4902 10.5C16.2086 10.5 15.9804 10.2761 15.9804 10Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9804 4C15.9804 3.7239 16.2086 3.5 16.4902 3.5C16.7718 3.5 17 3.7239 17 4C17 4.2761 16.7718 4.5 16.4902 4.5C16.2086 4.5 15.9804 4.2761 15.9804 4Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 16L3 16",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 10L3 10",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 4L3 4",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueContentsListStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;